import { SpriteConstant } from './../../../constant/sprite.constant';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class TableInfopopupLayoutComponent implements OnInit {
  @Input() data: any;
  @Output() eventEmit: EventEmitter<string> = new EventEmitter<string>();
  @Input() currentLanguage = 'en';
  rptInfo: any = {};
  isMac = '';
  constructor() {}

  ngOnInit() {
    this.setRTPData();
  }

  setRTPData() {
    this.rptInfo.naturals = [
      this.getRTPString(this.data.info.supernatural),
      this.getRTPString(this.data.info.naturaltwentyone),
      this.getRTPString(this.data.info.doublenatural),
      this.getRTPString(this.data.info.naturalzero),
    ];
    this.rptInfo.insurance = [
      this.getRTPString(this.data.info.colorcardinsurance),
      this.getRTPString(this.data.info.whitecardinsurance),
    ];
    this.rptInfo.roulette = [
      this.getRTPString(this.data.info.russianroulette17),
      this.getRTPString(this.data.info.russianroulette18),
      this.getRTPString(this.data.info.russianroulette19),
      this.getRTPString(this.data.info.russianroulette20),
    ];
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onCloseClick();
  }
  getRTPString(str) {
    const ratioStr = str.split('/')[0].trim();
    let returnStr = '';
    returnStr = ratioStr.split(':')[0] + '_' + ratioStr.split(':')[1];
    return returnStr;
  }

  onCloseClick = (event = null) => {
    this.eventEmit.emit('close');
  };

  onInfoClick = (event) => {
    this.eventEmit.emit('info_' + event);
  };
}
